exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".grant-type-selection .grant-buttons .el-button.el-button--default{width:100%;height:120px;margin-top:8px}.grant-type-selection .grant-buttons .el-button.el-button--danger{width:100%;margin-top:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b1696348","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/cross-components/change-user-grant-level-modal.vue
// module id = 433
// module chunks = 0